import { gql, type TypedDocumentNode } from '@apollo/client';
import type { OrganizationSettingsQuery, OrganizationSettingsQueryVariables } from 'types/graphql';

/** The app-wide organization settings read; RoutesBridge mirrors it into `useOrgSettings`, writes refetch it. */
export const ORGANIZATION_SETTINGS_QUERY: TypedDocumentNode<
  OrganizationSettingsQuery,
  OrganizationSettingsQueryVariables
> = gql`
  query OrganizationSettingsQuery {
    organization {
      id
      label
      gs1CompanyPrefix
      salesOrderDocumentPrefix
      closedAt
      hasLedger
      productDescriptionTemplate
    }
    financeConfiguration {
      id
      defaultAssetsAccountId
      defaultLiabilitiesAccountId
      defaultExpensesAccountId
      defaultIncomeAccountId
      autoCloseFractionalBalances
      fractionalBalanceThresholdCents
      fractionalBalanceAdjustmentAccountId
    }
    orgSettings {
      id
      unitRounding
    }
  }
`;
